import { configureStore } from '@mafc/common';
import productReducers from './product';

const initialState = {};
const store = configureStore(initialState, { productReducers });

export default store;
